// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ref{display:inline-block;position:relative}.ref-content{color:#00f;text-decoration:underline}.modal{position:absolute;left:0;background-color:#fff;padding:.5rem;box-shadow:var(--box-shadow);z-index:2;top:100%}.modal button,.modal input{font-size:1rem;padding:8px 12px}.modal button{background-color:var(--primary-color,#008fc1);color:#fff;border:0;outline:0;margin-left:auto;border-radius:4px;margin-top:.5rem;display:block;font-weight:500;cursor:pointer}", ""]);
// Exports
module.exports = exports;
